export default __webpack_public_path__ + "static/media/logo-big-shop.31593c62.png";